import "./style.scss";
import TextSettings from "@builder/components/app/Popup/popups/DynamicData/CheckoutFlowSettings/TextSettings";
import { useAppSelector } from "@builder/store/store";
import ImageSettings from "@builder/components/app/Popup/popups/DynamicData/CheckoutFlowSettings/ImageSettings";

const CheckoutFlowData = ({ type }: { type?: string | null }) => {
    const buildSettingsKey = useAppSelector(state => state.buildSettingsKey);
    const imageKeys = Object.values(buildSettingsKey).filter(setting => setting.dataType === "url");
    const textKeys = Object.values(buildSettingsKey).filter(setting => setting.dataType === "text");

    return (
        <div className="checkout-flow-wrapper">
            {type === "image" && <ImageSettings settings={imageKeys} />}
            {type !== "image" && <TextSettings settings={textKeys} />}
        </div>
    );
};

export default CheckoutFlowData;
